import { createSelector } from '@ngrx/store';
import * as retirementPlanState from '../employee-detail.reducer';
import * as retirementPlanReducer from '../reducers/retirement-plan.reducer';

export const getRetirementPlan = createSelector(retirementPlanState.getRetirementPlanState, retirementPlanReducer.getRetirementPlan);
